import React from 'react';
import { XRayMaterial } from './XRayMaterial';

interface MannequinClothingProps {
  gender: 'male' | 'female';
  part: 'pelvis' | 'leftHip' | 'rightHip' | 'torso' | 'stomach' | 'chest' | 'leftShoulder' | 'rightShoulder';
}

export const MannequinClothing: React.FC<MannequinClothingProps> = ({ gender, part }) => {
  const isMale = gender === 'male';

  // Colors
  const MALE_SHIRT_COLOR = '#3b82f6'; // Deep slate/athletic blue
  const MALE_SHORTS_COLOR = '#334155'; // Charcoal grey
  const FEMALE_SHIRT_COLOR = '#0d9488'; // Warm teal
  const FEMALE_SHORTS_COLOR = '#1e293b'; // Snug slate black

  switch (part) {
    case 'pelvis':
      return isMale ? (
        <mesh position={[0, 0.55, 0]} scale={[1.1, 1.0, 0.65]} raycast={() => null}>
          <cylinderGeometry args={[1.15, 1.15, 1.15, 16]} />
          <XRayMaterial color={MALE_SHORTS_COLOR} />
        </mesh>
      ) : (
        <mesh position={[0, 0.65, 0]} scale={[1.0, 1.0, 0.62]} raycast={() => null}>
          <cylinderGeometry args={[1.05, 1.15, 1.3, 16]} />
          <XRayMaterial color={FEMALE_SHORTS_COLOR} />
        </mesh>
      );

    case 'leftHip':
    case 'rightHip':
      return isMale ? (
        <mesh position={[0, -1.4, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.36, 0.36, 2.8, 16]} />
          <XRayMaterial color={MALE_SHORTS_COLOR} />
        </mesh>
      ) : (
        <mesh position={[0, -0.9, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.3, 0.3, 1.8, 16]} />
          <XRayMaterial color={FEMALE_SHORTS_COLOR} />
        </mesh>
      );

    case 'torso':
      return isMale ? (
        <mesh position={[0, 1.11, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.34, 0.36, 2.22, 16]} />
          <XRayMaterial color={MALE_SHIRT_COLOR} />
        </mesh>
      ) : (
        <mesh position={[0, 1.11, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.28, 0.32, 2.22, 16]} />
          <XRayMaterial color={FEMALE_SHIRT_COLOR} />
        </mesh>
      );

    case 'stomach':
      return isMale ? (
        <mesh position={[0, 1.02, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.34, 0.34, 2.04, 16]} />
          <XRayMaterial color={MALE_SHIRT_COLOR} />
        </mesh>
      ) : (
        <mesh position={[0, 1.02, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.26, 0.28, 2.04, 16]} />
          <XRayMaterial color={FEMALE_SHIRT_COLOR} />
        </mesh>
      );

    case 'chest':
      return isMale ? (
        <mesh position={[0, 0.66, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.36, 0.34, 1.32, 16]} />
          <XRayMaterial color={MALE_SHIRT_COLOR} />
        </mesh>
      ) : (
        <mesh position={[0, 0.66, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.22, 0.26, 1.32, 16]} />
          <XRayMaterial color={FEMALE_SHIRT_COLOR} />
        </mesh>
      );

    case 'leftShoulder':
    case 'rightShoulder':
      return isMale ? (
        <mesh position={[0, -0.7, 0]} raycast={() => null}>
          <cylinderGeometry args={[0.28, 0.28, 1.4, 16]} />
          <XRayMaterial color={MALE_SHIRT_COLOR} />
        </mesh>
      ) : null;

    default:
      return null;
  }
};
